import { useNativeStore } from '~/features-generic/mobile/stores/native'

export function useServiceWorker() {
  const store = useNativeStore()
  /* Should notify update ui */
  const showUpdate = computed(() => store.$state.displayWindowBarUpdate)
  /* Get native update info if any */
  const nativeUpdateInfo = computed(() => store.$state.nativeUpdateInfo)
  /* Get native info if switching platform */
  const nativeSwitchPlatform = computed(() => store.$state.isSNewPlatform)
  /* Get native info if use autoReload */
  const allowAutoReload = computed(() => store.$state.useAutoReload)
  /* Get native setting if use useUpdateUI */
  const useUpdateUI = computed(() => store.$state.useUpdateUI)

  const notifyAppSWReady = () => {
    return store.notifyAppSWReady()
  }
  const notifyUpdateAvailable = () => {
    store.notifyUpdateAvailable(true, { pwaUpdateOnly: true })
  }
  const notifyAppToUpdate = (info: any) => {
    store.notifyAppToUpdate(info)
  }
  const notifyAppToPostponeUpdate = (info: any) => {
    store.notifyAppToPostponeUpdate(info)
  }

  return {
    showUpdate,
    nativeUpdateInfo,
    nativeSwitchPlatform,
    allowAutoReload,
    useUpdateUI,
    notifyAppSWReady,
    notifyUpdateAvailable,
    notifyAppToUpdate,
    notifyAppToPostponeUpdate,
  }
}

export const useServiceWorkerWrapper = {
  updateSW: (_reloadPage?: boolean) => {},
}
